import React, {useCallback, useReducer, useRef, useMemo} from "react";
import _ from "lodash";

const init = (initialState) => {
    return calculateIndices({
        stepsMap: initialState.stepsMap,
        stepPaths: initialState.stepPaths,
        currentStep: initialState.initialStep,
        currentStepPath: initialState.initialPath,
        previousStep: null,
        state: initialState.initialState || {}
    })
};

const calculateIndices = (state) => {
    const {stepPaths, currentStepPath, currentStep, previousStep} = state;
    const currentStepIndex =  _.findIndex(stepPaths[currentStepPath], {key: currentStep});
    const previousStepIndex =  _.findIndex(stepPaths[currentStepPath], {key: previousStep});
    const showSteps = _.take(stepPaths[currentStepPath], currentStepIndex + 1);
    return {...state, currentStepIndex, previousStepIndex, showSteps};
};

const reducer = (state, action) => {
    const {type, payload} = action;

    switch (type) {
        case "SET-STEP": {
            const { step } = payload;
            return calculateIndices({...state, currentStep: step, previousStep: state.currentStep});
        }
        case "SET-STEP-PATH": {
            const { step, stepPath } = payload;
            return calculateIndices({...state, currentStep: step, previousStep: state.currentStep, currentStepPath: stepPath});
        }
        case "SET-STATE": {
            const {mergeState} = payload;
            return {...state, state: {...state.state, ...mergeState}}
        }
        case "RESET-STATE": {
            return {...state, state: {}}
        }
        case "GO-TO-PREVIOUS-STEP": {
            const step = state.stepPaths[state.currentStepPath][state.currentStepIndex - 1].key;
            return calculateIndices({...state, currentStep: step, previousStep: state.currentStep});
        }
        case "GO-TO-NEXT-STEP": {
            const step = state.stepPaths[state.currentStepPath][state.currentStepIndex + 1].key;
            return calculateIndices({...state, currentStep: step, previousStep: state.currentStep});
        }
    }

    return state;
};

export default ({stepsMap, stepPaths, initialStep, initialPath, initialState}) => {
    const [wizardState, dispatch] = useReducer(reducer, {stepsMap, stepPaths, initialStep, initialPath, initialState}, init);
    const {currentStep, previousStep, currentStepPath, currentStepIndex, previousStepIndex, showSteps, state} = wizardState;
    const stateRef = useRef(null);
    stateRef.current = state;

    const gotoPreviousStep = useCallback(() => {
        dispatch({
            type: "GO-TO-PREVIOUS-STEP"
        })
    }, [dispatch]);

    const setStep = useCallback((step) => {
        dispatch({
            type: "SET-STEP",
            payload: {
                step
            }
        })
    }, [dispatch]);

    const setStepPath = useCallback((step, stepPath) => {
        dispatch({
            type: "SET-STEP-PATH",
            payload: {
                step,
                stepPath
            }
        })
    }, [dispatch]);

    const setState = useCallback((state) => {
        dispatch({
            type: "SET-STATE",
            payload: {
                mergeState: state
            }
        })
    }, [dispatch]);

    const resetState = useCallback(() => {
        dispatch({
            type: "RESET-STATE"
        })
    }, [dispatch]);

    const goToNextStep = useCallback(() => {
        dispatch({
            type: "GO-TO-NEXT-STEP"
        })
    }, [dispatch]);

    const getState = useCallback(() => {
        return stateRef.current;
    }, []);

    return useMemo(() => {
        return {setStep, setStepPath, currentStep, previousStep, currentStepPath, currentStepIndex, previousStepIndex, showSteps, setState, state, stepsMap, stepPaths, gotoPreviousStep, resetState, getState, goToNextStep};
    }, [setStep, setStepPath, currentStep, previousStep, currentStepPath, currentStepIndex, previousStepIndex, showSteps, setState, state, stepsMap, stepPaths, gotoPreviousStep, resetState, getState, goToNextStep]);
};
